<template>
  <div class="box">
    <div v-if="canHaveDocument && canEdit" class="newDocument pt-4 pl-4">
      <div>
        <input
          id="fileUpload"
          ref="file"
          type="file"
          v-on:change="handleFileUpload()"
        />
      </div>
    </div>
    <div class="documentList">
      <v-list-item v-if="!canHaveDocument" v-bind:key="index">
        <v-list-item-content>
          <v-list-item-title class="font-s text-gray px-5 text-center"
            >Bitte wählen Sie ein Element aus</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list v-if="canHaveDocument">
        <v-subheader>
          <h6>Hochgeladene Dateien</h6>
        </v-subheader>
        <v-list-item-title
          v-if="canHaveDocument && uploadedFiles.length == 0"
          class="font-s text-gray px-5 pt-10 text-center"
        >
          Es gibt noch keine hochgeladene Datei
        </v-list-item-title>
        <v-list-item
          v-for="file in uploadedFiles"
          :key="file.id"
          class="border-bottom"
        >
          <v-list-item-content>
            <v-list-item-title
              v-text="file.fileName"
              class="font-m"
            ></v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon @click="downloadFile(file)" class="pointer">
            <v-icon color="gray">mdi-file-download-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-icon @click="deleteFile(file.id)" class="pointer">
            <v-icon color="gray">mdi-delete</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </div>
  </div>
</template>

<script>
import documentService from "./document-service";

export default {
  components: {},
  props: {
    uuid: String,
    elementId: String,
    canEdit: Boolean,
  },
  data: function () {
    return {
      uploadedFiles: [],
      canHaveDocument: true,
    };
  },
  mounted: function () {
    if (
      this.elementId.includes("Collaboration") ||
      (this.elementId.includes("Process") && !this.elementId.includes("Sub"))
    ) {
      this.canHaveDocument = false;
    } else {
      this.canHaveDocument = true;
      this.loadDocuments();
    }
  },
  watch: {
    elementId: function (val) {
      if (
        this.elementId.includes("Collaboration") ||
        (this.elementId.includes("Process") && !this.elementId.includes("Sub"))
      ) {
        this.canHaveDocument = false;
      } else {
        this.canHaveDocument = true;
        this.loadDocuments();
      }
    },
  },
  methods: {
    loadDocuments() {
      documentService
        .getDocumentList(this.uuid, this.elementId)
        .then((res) => {
          this.uploadedFiles = res.data;
        })
        .catch((e) => console.log(e));
    },
    handleFileUpload() {
      var formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      documentService
        .saveDocument(formData, this.uuid, this.elementId)
        .then((res) => {
          this.$refs.file.value = null;
          this.loadDocuments();
          this.$emit("refresh");
        })
        .catch((e) => console.log(e));
    },
    downloadFile(documentInfo) {
      documentService
        .downloadDocument(this.uuid, this.elementId, documentInfo.id)
        .then((res) => {
          console.log(res);
          if (res.data == "") return;
          const blob = new Blob([res.data]);
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = documentInfo.fileName;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((e) => console.log(e));
    },
    deleteFile(documentId) {
      documentService
        .removeDocument(this.uuid, this.elementId, documentId)
        .then((res) => {
          if (this.uploadedFiles.length == 1) {
            this.$emit("refresh");
          }
          this.loadDocuments();
        })
        .catch((e) => console.log(e));
    },
  },
};
</script>
<style scoped>
.documentList,
.newDocument {
  /*position: absolute;*/
}
.documentList {
  overflow-y: auto;
}
.newDocument {
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
}
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
}
</style>